import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({ baseURL: API_URL });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('streamToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

class TaxService {
  // public
  static async active() {
    const { data } = await api.get('/tax');
    return data.data; // { enabled, rates }
  }
  static async preview(subtotalCents) {
    const { data } = await api.get('/tax/preview', { params: { subtotal: Math.round(subtotalCents) } });
    return data.data; // { subtotal, taxLines, taxTotal, total }
  }

  // admin
  static async adminList() {
    const { data } = await api.get('/tax/admin');
    return data.data; // { tax_enabled, rates }
  }
  static async setEnabled(enabled) {
    await api.put('/tax/admin/toggle', { tax_enabled: !!enabled });
  }
  static async create(rate) {
    const { data } = await api.post('/tax/admin', rate);
    return data.data;
  }
  static async update(id, rate) {
    const { data } = await api.put(`/tax/admin/${id}`, rate);
    return data.data;
  }
  static async remove(id) {
    await api.delete(`/tax/admin/${id}`);
  }
}

export default TaxService;
